export const POLYGON = 'POLYGON'
export const DISTANCE = 'DISTANCE'
